import { EmailConfigModel } from '../shared/models/service-models/EmailConfig.model'
import RequestFactory from './RequestFactory'

const gmaUrl = process.env.REACT_APP_GMAE2E_URL

const EmailConfigService = {
  getConfig: async () => {
    return (await RequestFactory.get(gmaUrl, `/api/email-config`)) as Promise<EmailConfigModel>
  },
}

export default EmailConfigService
